<template>
  <div v-if="initialised">
    <b-modal
      :id="uniqueClass"
      ref="beforeAndAfterModal"
      size="xl"
      title-class="w-100 row"
      @show="showingModal"
      @hide="hidingModal"
    >
      <template #modal-title>
        <div class="col">Before And After</div>
        <div class="col text-right">JOB #{{ jobId }}</div>
      </template>
      <div class="row before-and-after-container">
        <div class="col">
          <div class="row">
            <div class="col py-1 text-18">Images</div>
          </div>
          <div class="row pt-2">
            <div class="col attachments-list">
              <ul v-if="files.length > 0" class="list-group overflow-y-auto" style="height: 500px">
                <li v-for="file in files" :key="file.id" class="list-group-item highlight">
                  <div
                    v-if="file.media[0] !== undefined && file.detail !== 'Before and After Image'"
                    class="w-100"
                  >
                    <template
                      v-if="
                        file.media[0].mime_type === 'image/jpeg' ||
                        file.media[0].mime_type === 'image/jpg' ||
                        file.media[0].mime_type === 'image/gif' ||
                        file.media[0].mime_type === 'image/png'
                      "
                    >
                      <img :src="getFileThumbnail(file)" alt="" style="max-width: 200px" />
                    </template>
                  </div>

                  <div class="text-muted text-12 mt-2">
                    {{ formatDate(file.created_at, "DD MMM YYYY@hh:mma") }}
                    by {{ file.user ? file.user.name : "Anonymous" }}
                  </div>
                  <div class="mt-2">
                    <b-button
                      variant="info"
                      size="sm"
                      class="mr-2"
                      @click.prevent="setBefore(file)"
                    >
                      Set BEFORE
                    </b-button>
                    <b-button variant="warning" size="sm" @click.prevent="setAfter(file)">
                      Set AFTER
                    </b-button>
                  </div>
                </li>
              </ul>
              <div v-else>
                <div class="text-muted">No file</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" style="margin-left: 10px; margin-right: 10px">
          <div class="row">
            <div class="col py-1 text-18">Before Image</div>
            <div class="col-12 selected-before">
              <img v-if="beforeImage" :src="beforeImage" alt="Before Image" />
            </div>
          </div>

          <div class="row">
            <div class="col py-1 text-18">After Image</div>
            <div class="col-12 selected-after">
              <img v-if="afterImage" :src="afterImage" alt="After Image" />
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="row">
          <div class="col d-flex align-items-end">
            <button class="btn btn-danger ml-auto" type="button" @click.prevent="clear">
              Reset
            </button>

            <button
              v-tooltip="{
                content: invalid,
                classes: ['badge-theme'],
              }"
              :class="invalid ? 'disabled' : ''"
              class="btn btn-primary ml-2"
              type="button"
              @click.prevent="generateBeforeAndAfter"
            >
              <font-awesome-icon v-if="generating" :icon="['fal', 'spinner']" spin />
              <font-awesome-icon v-else :icon="['fal', 'envelope-open-text']" />
              Generate Before And After Image
            </button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script type="text/babel">
import EventBus from "../../imports/event-bus";
import format from "../../mixins/format";

export default {
  mixins: [format],

  props: {
    jobId: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      initialised: false,
      uniqueClass: null,
      generating: false,

      files: [],

      beforeImage: null,
      afterImage: null,
      beforeImageObject: null,
      afterImageObject: null,
    };
  },

  computed: {
    invalid() {
      if (this.generating) {
        return "Generating the Before And Ater image right now";
      }

      if (!this.beforeImageObject || !this.afterImageObject) {
        return "You must select both a Before and After image";
      }

      return false;
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.initialised = false;
      this.generating = false;

      this.files = [];
      this.beforeImage = null;
      this.afterImage = null;
      this.beforeImageObject = null;
      this.afterImageObject = null;

      this.uniqueClass = `before-and-after-${window.generateUUID()}`;

      this.initialised = true;
    },

    showingModal() {
      this.getAttachments();
    },

    hidingModal() {
      this.init();
    },

    getAttachments() {
      this.$http.get(`/jobs/${this.jobId}/job-notes?media_only=true&limit=999`).then((response) => {
        this.files = response.body.data.filter((file) => {
          return (
            file.media[0] !== undefined &&
            file.detail !== "Before and After Image" &&
            file.media[0].mime_type.startsWith("image/")
          );
        });
      });
    },

    getFileThumbnail(file) {
      if (this.$lodash.has(file, "media[0].thumbnails[300]")) {
        return file.media[0].thumbnails[300];
      }

      if (this.$lodash.has(file, "media[0].thumbnails[600]")) {
        return file.media[0].thumbnails[600];
      }

      if (this.$lodash.has(file, "media[0].url")) {
        return file.media[0].url;
      }

      return "";
    },

    showModal() {
      this.$nextTick(() => {
        this.$refs.beforeAndAfterModal.show();
      });
    },

    setBefore(file) {
      if (this.afterImageObject && this.afterImageObject.id === file.id) {
        window.toastr.error("You cannot set the same image as both Before and After");
        return;
      }

      this.beforeImage = null;
      this.beforeImageObject = null;

      if (file) {
        this.beforeImageObject = file;
        this.beforeImage = this.$lodash.get(file, "media[0].thumbnails[300]", null);
      }
    },

    setAfter(file) {
      if (this.beforeImageObject && this.beforeImageObject.id === file.id) {
        window.toastr.error("You cannot set the same image as both Before and After");
        return;
      }

      this.afterImage = null;
      this.afterImageObject = null;

      if (file) {
        this.afterImageObject = file;
        this.afterImage = this.$lodash.get(file, "media[0].thumbnails[300]", null);
      }
    },

    async generateBeforeAndAfter() {
      if (this.invalid) {
        return;
      }

      this.generating = true;

      const response = await this.$http.post("/job-notes/before-and-after", {
        job_id: this.jobId,
        before_image_id: this.beforeImageObject ? this.beforeImageObject.id : null,
        after_image_id: this.afterImageObject ? this.afterImageObject.id : null,
      });

      if (response.status === 201) {
        window.toastr.success("Before and After image created successfully");

        EventBus.$emit("before-and-after-image-created", response.body.data);

        this.$refs.beforeAndAfterModal.hide();
      } else {
        window.toastr.error("There was an error creating the Before and After image");
      }

      this.generating = false;
    },

    clear() {
      this.beforeImage = null;
      this.afterImage = null;
      this.beforeImageObject = null;
      this.afterImageObject = null;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.before-and-after-container .selected-before,
.before-and-after-container .selected-after {
  padding: 0;
  height: 230px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.before-and-after-container .selected-before img,
.before-and-after-container .selected-after img {
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}
</style>
